import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalUploadPageRoutingModule } from './modal-upload-routing.module';

import { ModalUploadPage } from './modal-upload.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalUploadPageRoutingModule
  ],
  declarations: [ModalUploadPage]
})
export class ModalUploadPageModule {}
